export default __webpack_public_path__ + "static/media/SEGMENT.cd7b87e6.svg";